import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { setFaroView } from '@/lib/faro'

/**
 * Reports SPA route changes to Faro so `view.name` is attached to every signal
 * (logs, events, traces) and a `view_changed` event is emitted on navigation.
 * No-op when Faro is not initialised (VITE_FARO_URL unset).
 */
export default function usePageViewTracking() {
    const { pathname } = useLocation()

    useEffect(() => {
        setFaroView(pathname)
    }, [pathname])
}
